'use client'

import React, { ReactNode, createContext } from 'react'

export type FeatureFlags = Record<string, boolean> | null

interface FeatureFlagsProviderProps {
    featureFlags: FeatureFlags
    children: ReactNode
}

export const FeatureFlagsContext = createContext<FeatureFlags | undefined>(undefined)

export const FeatureFlagsProvider = ({ featureFlags, children }: FeatureFlagsProviderProps) => {
    return <FeatureFlagsContext.Provider value={featureFlags}>{children}</FeatureFlagsContext.Provider>
}
